export default __webpack_public_path__ + "static/media/sketch.695dde69.svg";